module.exports = __webpack_public_path__ + "static/media/7.989df2c5.png";